<template>
    <section
        class="features-tiles section center-content"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="features-tiles-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content" />
                <div
                    class="tiles-wrap"
                    :class="[
                        pushLeft && 'push-left',
                    ]">
                    <div class="tiles-item reveal-scale-down" data-reveal-container=".tiles-wrap">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-01.svg')"
                                        alt="Feature tile icon 01"
                                        :width="64"
                                        :height="64" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Infinite canvas
                                </h4>
                                <p class="m-0 text-sm">
                                    Forget about image boundaries and canvas dimensions, and use annotations and images anywhere you want in or outside your captures.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-down" data-reveal-container=".tiles-wrap" data-reveal-delay="100">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-02.svg')"
                                        alt="Feature tile icon 02"
                                        :width="64"
                                        :height="64" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    12 capture modes
                                </h4>
                                <p class="m-0 text-sm">
                                    Choose among twelve unique methods of capturing your screen, for everything from taking timed screenshots of screen regions to recording videos of them.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-down" data-reveal-container=".tiles-wrap" data-reveal-delay="200">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-03.svg')"
                                        alt="Feature tile icon 03"
                                        :width="64"
                                        :height="64" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Shortcuts, everywhere
                                </h4>
                                <p class="m-0 text-sm">
                                    Recover lost minutes of application opening, file searching, and image importing with just a few intuitive keyboard shortcuts. 
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-down" data-reveal-container=".tiles-wrap" data-reveal-delay="300">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-04.svg')"
                                        alt="Feature tile icon 04"
                                        :width="64"
                                        :height="64" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Automated organization
                                </h4>
                                <p class="m-0 text-sm">
                                    Website links and application names are automatically identified whenever you take a screenshot, and used to organize your screenshots for you.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-down" data-reveal-container=".tiles-wrap" data-reveal-delay="400">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-05.svg')"
                                        alt="Feature tile icon 05"
                                        :width="64"
                                        :height="64" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Share in seconds
                                </h4>
                                <p class="m-0 text-sm">
                                    Send images directly where they matter next with built-in screenshot sharing via email templates, Jira & Office 365 integrations, and much more.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-down" data-reveal-container=".tiles-wrap" data-reveal-delay="500">
                        <div class="tiles-item-inner">
                            <div class="features-tiles-item-header">
                                <div class="features-tiles-item-image mb-16">
                                    <c-image
                                        :src="require('@/assets/images/feature-tile-icon-06.svg')"
                                        alt="Feature tile icon 06"
                                        :width="64"
                                        :height="64" />
                                </div>
                            </div>
                            <div class="features-tiles-item-content">
                                <h4 class="mt-0 mb-8">
                                    Blazingly fast
                                </h4>
                                <p class="m-0 text-sm">
                                    Optimized exclusively for Windows systems, Pixtel runs with minimal lag and battery usage, even with thousands of images open at once.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CImage from '@/components/elements/Image.vue'

export default {
  name: 'CFeaturesTiles',
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: '',
        paragraph: ''
      }
    }
  }
}
</script>